/* eslint-disable no-unused-vars */
import React from 'react'

export default function AllPlans() {
  return (
    <div>AllPlans</div>
  )
}
